webpackJsonp([49],{

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_resource_action_vue__ = __webpack_require__(778);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73686370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_resource_action_vue__ = __webpack_require__(926);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_resource_action_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73686370_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_resource_action_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_resources_resource_action_form__ = __webpack_require__(922);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function closeModal() {
	this.goTo('page-resource');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-resource-action',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["default"],
		resourceActionForm: __WEBPACK_IMPORTED_MODULE_1__components_resources_resource_action_form__["a" /* default */]
	},
	methods: {
		closeModal: closeModal
	},
	props: {
		id: {
			type: [Number, String]
		},
		codeProject: {
			type: String
		},
		name: {
			type: String,
			required: true
		}
	}
});

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_resources_resource_action_list__ = __webpack_require__(923);





var loadActions = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var params, headers, _ref2, actions;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = this.actionParams;
						headers = this.version;
						_context.prev = 2;
						_context.next = 5;
						return this.$http.get('action-list', { params: params, headers: headers });

					case 5:
						_ref2 = _context.sent;
						actions = _ref2.data;

						this.actions = actions.data.map(function (action) {
							var newAction = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, action);
							var keyLanguages = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(action.languages);
							var firstLanguages = keyLanguages[0];
							newAction[_this.selectedValue] = action[_this.selectedValue] === 1;
							newAction.name = action.languages.es ? action.languages.es.name : action.languages[firstLanguages].name;
							return newAction;
						});
						this.checkAll = this.every(this.actions, this.selectedValue);
						_context.next = 14;
						break;

					case 11:
						_context.prev = 11;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 14:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 11]]);
	}));

	return function loadActions() {
		return _ref.apply(this, arguments);
	};
}();

var submitForm = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _this2 = this;

		var actionsSelected, actions, headers;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						actionsSelected = this.actions.filter(function (action) {
							return action[_this2.selectedValue];
						});
						actions = actionsSelected.map(function (p) {
							var newArray = {};
							newArray.id = p.id;
							newArray.flagSelected = p.flagSelected;
							return newArray;
						});
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};

						this.loading = true;
						_context2.prev = 4;
						_context2.next = 7;
						return this.$http.post('resource/' + this.resourceId + '/actions', { actions: actions }, { headers: headers });

					case 7:
						this.showNotification('La barra de acciones ha sido asignada correctamente');
						this.goTo(PAGE_RESOURCE_LIST);

					case 9:
						_context2.prev = 9;

						this.loading = false;
						return _context2.finish(9);

					case 12:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[4,, 9, 12]]);
	}));

	return function submitForm() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var PAGE_RESOURCE_LIST = 'page-resource';

function created() {
	this.actionParams.codeProject = this.codeProject;
	this.actionParams.resourceId = this.resourceId;
	this.loadActions();
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.actions = this.selectIsRow(this.actions, this.selectedValue, false, checked);
}

function buttonDisabled() {
	return this.every(this.actions, this.selectedValue, true) || this.loading;
}

function closeModal() {
	this.goTo(PAGE_RESOURCE_LIST);
}

function onSearchList(value) {
	this.actionParams.search = value;
	this.loadActions();
}

function rowIsSelected(row) {
	this.actions = this.selectIsRow(this.actions, this.selectedValue, row);
	this.checkAll = this.every(this.actions, this.selectedValue);
}

function data() {
	return {
		actionParams: {
			codeProject: '',
			resourceId: 0
		},
		actions: [],
		checkAll: false,
		columns: [{ id: 1, name: 'Nombre', checked: true, visible: true }, { id: 2, name: 'Código', checked: true, visible: true }, { id: 3, name: 'Url Web', checked: true, visible: true }, { id: 4, name: 'Fragment Móvil', checked: true, visible: true }],
		loading: false,
		selectedValue: 'flagSelected',
		version: {
			Accept: '' + 'application/vnd.apiacl.v2+json'
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'resource-action-form',
	components: {
		resourceActionList: __WEBPACK_IMPORTED_MODULE_4__components_resources_resource_action_list__["a" /* default */]
	},
	computed: {
		buttonDisabled: buttonDisabled
	},
	created: created,
	data: data,
	methods: {
		allIsSelected: allIsSelected,
		closeModal: closeModal,
		loadActions: loadActions,
		onSearchList: onSearchList,
		rowIsSelected: rowIsSelected,
		submitForm: submitForm
	},
	props: {
		codeProject: {
			type: String,
			required: true
		},
		resourceId: {
			type: [Number, String],
			required: true
		},
		resourceName: {
			type: String,
			required: true
		}
	}
});

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'resource-action-list',
	methods: {
		allIsSelected: allIsSelected,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		checkAll: {
			type: Boolean,
			required: true
		},
		columns: {
			type: Array,
			required: true
		},
		rows: {
			type: Array,
			required: true
		},
		selectedValue: {
			type: String,
			required: true
		}
	}
});

/***/ }),

/***/ 922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_action_form_vue__ = __webpack_require__(779);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22df17c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_action_form_vue__ = __webpack_require__(925);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_action_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22df17c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_action_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_action_list_vue__ = __webpack_require__(780);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4519d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_action_list_vue__ = __webpack_require__(924);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resource_action_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4519d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resource_action_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-table',{staticClass:"mt-3 no-main-list",attrs:{"name":"resource-actions","selectable":"","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"main-list":false,"rows":_vm.rows},on:{"on-search-event":_vm.onSearch,"on-selected-all":_vm.allIsSelected,"row-is-selected":_vm.rowIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.code)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.codeWeb)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.numFragment)+"\n\t\t\t")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-subheader',[_vm._v("Recurso: "+_vm._s(_vm.resourceName))])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('resource-action-list',{attrs:{"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.actions,"selected-value":_vm.selectedValue},on:{"all-is-selected":_vm.allIsSelected,"on-search":_vm.onSearchList,"row-is-selected":_vm.rowIsSelected}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.buttonDisabled,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.submitForm,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Asignar Barra de Acciones","value":true},on:{"close-modal":_vm.closeModal}},[_c('resource-action-form',{attrs:{"code-project":_vm.codeProject,"resource-id":_vm.id,"resource-name":_vm.name}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/49.01027d0224bd2f3396cd.js